/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import {
  DELETE_APPLICATION,
  DELETE_APPLICATION_APPLICANT,
} from '../../api/graphql';
import { vappContainer } from '@/application';
import { notificationConfig } from '../../config/notifications.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface deleteDraftProps {
  email: string;
}

export interface IDeleteDraftMethods extends IPluginMethodMap {
  getDeleteDraft(args: deleteDraftProps): Promise<any>;
}

export class DeleteDraftService implements IAgentPlugin {
  readonly methods: IDeleteDraftMethods;

  constructor() {
    this.methods = {
      getDeleteDraft: this.getDeleteDraft.bind(this),
    };
  }

  async getDeleteDraft(args: deleteDraftProps) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);

    console.log('whoAmIwhoAmI', whoAmI);

    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client.mutation(
          whoAmI === 'prospective_employee'
            ? DELETE_APPLICATION_APPLICANT
            : DELETE_APPLICATION,

          {
            applicationNo: args,
          }
        );

        // .mutate({
        //   mutation: DELETE_USER,
        //   variables: {
        //     vuid: args,
        //   },
        //   fetchPolicy: 'no-cache',
        // });
        if (res?.data) {
          return {
            ...res?.data?.deleteApplication,
            notification: notificationConfig?.deleteDraftSuccess,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
